import axiosHttp from "services/axiosHttp";
import moment from "moment/moment";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchTtenDownload = createAsyncThunk("fetchTtenDownload", async (documentId, { rejectWithValue }) => {
  const params = new URLSearchParams({
      year: moment().format("YYYY"),
    });

  try {
    const response = await axiosHttp.get(`tten/getttendoc/${documentId}`, {
      responseType: 'blob'
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Something went wrong");
  }
});

const TtenDownloadSlice = createSlice({
  name: "TtenDownloadSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchTtenDownload.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchTtenDownload.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });

    builder.addCase(fetchTtenDownload.rejected, (state, action) => {
      state.isLoading = false;

      if (action.error.message) {
        state.error = action.error.message;
      } else {
        state.error = "Unknown error occurred";
      }
    });
  },
});

export default TtenDownloadSlice.reducer;
